module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/yg-ef212cbf1e8201ac78c95542effe66ca.png";